import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales April 2026 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13)
// Source CSV: sample csv/2025 TLLG Marketing Leads Report - Cody - Sales Apr26.csv
// 20 valid jobs; trailing blank rows (27-37) and Totals row (38) excluded per processing rules.
// Trade names: "ROI " prefix stripped, multi-trade entries use first trade only:
//   - E-974 Ellicott Hills: "ROI Siding, ROI Gutters" -> "Siding"
//   - E-992 Ellicott hills: "Painting & Others, ROI Roofing" -> "Painting & Others"
//   - E-984 Beahm: "Windows & Doors, ROI Siding" -> "Windows & Doors"
//   - E-957 Mazhari: "ROI Siding, ROI Gutters" -> "Siding"
// Sum-of-rows used per Rule 1 (CSV Totals row GP $141,910.70 vs sum $141,910.69 — $0.01 rounding).
const jobData = [
  {
    jobInfo: "E-948: Richard Gaynor",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 89482.62,
    grossMarginPct: 0.5268,
    grossProfit: 47139.44,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 89482.62 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-999: Larry La",
    leadSource: "Referral- Cody's network",
    trade: "Gutters",
    contractTotal: 3452.00,
    grossMarginPct: 0.4508,
    grossProfit: 1556.16,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3452.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-997: Aion Management The Ridge PO #161704",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 24949.00,
    grossMarginPct: 0.3725,
    grossProfit: 9293.50,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 24949.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-974: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 699.00,
    grossMarginPct: 0.6567,
    grossProfit: 459.03,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 699.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-973: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 599.00,
    grossMarginPct: 0.5993,
    grossProfit: 358.98,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 599.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-994: Adam Winer",
    leadSource: "Referral- Cody's network",
    trade: "Miscellaneous",
    contractTotal: 787.50,
    grossMarginPct: 0.4921,
    grossProfit: 387.53,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 787.50 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-981: Tabor Design Build",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 527.89,
    grossMarginPct: 0.4317,
    grossProfit: 227.89,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 527.89 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-971: Donald Welsh",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 6040.00,
    grossMarginPct: 0.4039,
    grossProfit: 2439.56,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6040.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1007: Solution Based Property Management",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 933.39,
    grossMarginPct: 0.4643,
    grossProfit: 433.37,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 933.39 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-993: Paul Clary",
    leadSource: "Referral- Dominic's network",
    trade: "Gutters",
    contractTotal: 550.00,
    grossMarginPct: 0.7405,
    grossProfit: 407.28,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 550.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-992: Ellicott hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Painting & Others",
    contractTotal: 3475.00,
    grossMarginPct: 0.7122,
    grossProfit: 2474.90,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3475.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-982: Ballard Green Condo 3",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 975.00,
    grossMarginPct: 0.4872,
    grossProfit: 475.02,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 975.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-969: Ballard Green Condo 3",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 2908.00,
    grossMarginPct: 0.3000,
    grossProfit: 872.40,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2908.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-970: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Flooring",
    contractTotal: 1200.00,
    grossMarginPct: 0.5000,
    grossProfit: 600.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1200.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-972: Billy Ganoe",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 26143.54,
    grossMarginPct: 0.5726,
    grossProfit: 14969.79,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 26143.54 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-966: Montgomery Airpark LLP",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 18763.20,
    grossMarginPct: 0.4820,
    grossProfit: 9043.86,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 18763.20 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-954: Sandra Matia",
    leadSource: "Referral- Dominic's network",
    trade: "Windows & Doors",
    contractTotal: 7465.85,
    grossMarginPct: 0.4640,
    grossProfit: 3464.15,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 7465.85 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-1008: Christian Macdonald",
    leadSource: "Referral- Cody's network",
    trade: "Painting & Others",
    contractTotal: 32915.77,
    grossMarginPct: 0.3513,
    grossProfit: 11563.31,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 32915.77 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-984: Mike and Linda Beahm",
    leadSource: "Referral- Dominic's network",
    trade: "Windows & Doors",
    contractTotal: 56290.00,
    grossMarginPct: 0.3243,
    grossProfit: 18254.85,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 56290.00 * 0.13,
    netProfit: 0
  },
  {
    jobInfo: "E-957: Ali Mazhari",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 39949.00,
    grossMarginPct: 0.4378,
    grossProfit: 17489.67,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 39949.00 * 0.13,
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesApril2026Data: ReportData = {
  kpis: {
    adSpend: 0,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 4,
    year: 2026
  }
};
